import React from "react";
import { SFAppBar } from "@sf-core";
import languages from "../../constants/languages";

import useTimer from "../../hooks/useTimer";

const HeaderLayout = ({ routes, menuOpen, onMenuOpen }) => {
  useTimer();
  return <SFAppBar languages={languages} routes={routes} menuOpen={menuOpen} onMenuOpen={onMenuOpen} />;
};

HeaderLayout.propTypes = {};

export default HeaderLayout;
